var _path, _circle, _path2, _path3, _path4, _rect, _rect2, _path5, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptycart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 650 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dbe8ec",
    d: "M603.90415,273.22651V255.03535A13.07945,13.07945,0,0,0,590.8247,241.9559h-46.166a13.07946,13.07946,0,0,1-13.07946-13.07946V210.68528a13.07945,13.07945,0,0,1,13.07946-13.07945h1.45764a13.07945,13.07945,0,0,0,13.07945-13.07945V166.33522a13.07945,13.07945,0,0,0-13.07945-13.07945H134.20918a13.07945,13.07945,0,0,0-13.07945,13.07945v18.19116a13.07945,13.07945,0,0,0,13.07945,13.07945h0a13.07945,13.07945,0,0,1,13.07945,13.07945v18.19116a13.07945,13.07945,0,0,1-13.07945,13.07946H83.6298a13.07945,13.07945,0,0,0-13.07945,13.07945v18.19116A13.07945,13.07945,0,0,0,83.6298,286.306h19.84658a13.07945,13.07945,0,0,1,13.07945,13.07945v18.19125a13.07945,13.07945,0,0,1-13.07945,13.07945h-.048A13.07945,13.07945,0,0,0,90.349,343.73557v18.19107a13.07945,13.07945,0,0,0,13.07945,13.07945h2.87139a13.07945,13.07945,0,0,1,13.07945,13.07946v18.19124a13.07946,13.07946,0,0,1-13.07945,13.07946H59.1753A13.07945,13.07945,0,0,0,46.09585,432.4357v18.19116A13.07945,13.07945,0,0,0,59.1753,463.70631h493.963a13.07945,13.07945,0,0,0,13.07945-13.07945V432.4357a13.07945,13.07945,0,0,0-13.07945-13.07945H541.79779a13.07946,13.07946,0,0,1-13.07945-13.07946V388.08555a13.07945,13.07945,0,0,1,13.07945-13.07946h26.73986a13.07945,13.07945,0,0,0,13.07945-13.07945V343.73557a13.07945,13.07945,0,0,0-13.07945-13.07946H560.426a13.07945,13.07945,0,0,1-13.07945-13.07945V299.38541A13.07945,13.07945,0,0,1,560.426,286.306H590.8247A13.07945,13.07945,0,0,0,603.90415,273.22651Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 304.318,
    cy: 289.277,
    r: 173.618,
    fill: "#dbe8ec"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ee781d",
    d: "M374.86651 227.70637c3.35352-2.89721 4.57715-6.55395 6.48-12.24 1.844-5.5105 5.25342-15.69873.36011-21.6001-2.60523-3.14209-6.81665-4.16723-11.88013-5.3999-5.522-1.34424-6.49878-.26709-10.43994-1.8-1.54492-.60107-7.86182-3.0581-10.08008-8.63989-1.468-3.69409.4082-4.85767 0-13.68017-.24341-5.261-.40112-7.928-2.15991-9.72-2.08057-2.11962-4.12158-1.1726-10.8-2.87988-5.00244-1.27881-7.62061-1.94824-10.08008-3.96-4.15039-3.395-2.63305-6.34668-7.2-12.24-1.8562-2.39526-5.00635-6.4602-10.08008-7.56006a14.88293 14.88293 0 00-11.51977 2.52c-9.95948 7.418-9.28589 31.60742 1.7998 44.63989 4.04932 4.7605 5.7041 3.584 13.32007 11.52a111.17307 111.17307 0 0113.67993 18c7.24951 11.63477 5.16016 12.27393 9 16.56006C344.85748 231.9322 365.17754 236.07673 374.86651 227.70637zM407.98638 222.30647c-6.68017-3.38061-7.19311-17.97314-4.67993-27.36011.43042-1.60742 3.65283-7.81347 10.08008-20.15991 6.21655-11.94165 6.89966-13.15185 7.56006-16.20019 2.09521-9.67139-1.471-12.76661 1.7998-18.35987 1.28272-2.19336 5.43262-4.73218 13.68018-9.72 9.98364-6.03784 10.31738-5.54858 12.96-7.92016 7.39966-6.64063 7.312-12.74585 10.8-12.96 4.34887-.26684 8.136 8.99952 11.52 17.28 6.25757 15.31177 10.48852 25.66431 5.76 33.48-2.9292 4.84156-6.93213 4.80152-11.16016 12.6001a79.756 79.756 0 00-3.96 9.72c-3.41235 9.22315-3.17139 10.42774-4.67993 12.96-3.31909 5.57154-8.95654 7.24561-15.12012 9.72C418.75128 214.93855 414.303 225.503 407.98638 222.30647zM401.86651 264.42634c-2.47485-3.38794-4.84253-9.46386-2.52-13.67993 1.55713-2.82666 3.84912-2.32446 10.8-7.2a33.75809 33.75809 0 007.56006-6.48c3.78906-4.6582 2.59033-6.74609 5.3999-10.8 5.52563-7.97339 16.65088-9.25928 17.63989-9.36011 6.37915-.65063 7.46533 1.81714 13.68018.36011a21.60363 21.60363 0 0010.43994-5.40015c4.53052-4.44335 4.10278-8.68554 6.48-9 2.96362-.39184 7.188 5.7295 8.28 11.88013 1.42725 8.03955-2.33447 17.0459-8.64014 22.67993-8.3435 7.45508-14.27514 2.8711-22.67993 10.8-5.58276 5.2666-4.30347 8.551-11.52 15.11988-3.35351 3.05249-7.27026 6.61767-13.31982 7.92016C416.66949 272.72981 406.95049 271.38606 401.86651 264.42634zM459.82647 302.58626c5.05982-18.6604 5.57056-16.08814 11.15991-34.91993 4.86817-16.4021 6.407-24.844 12.6001-26.63989 3.97314-1.1521 8.99414.68311 10.08008 1.07983 6.68115 2.44166 7.70141 6.75025 11.52 6.48 4.22339-.29883 7.708-5.9043 9-10.07984 2.07275-6.69922-1.30811-10.33349 1.43994-14.04a10.014 10.014 0 0110.08008-3.24c8.45483 2.48047 13.16211 21.009 8.63989 35.28-3.44189 10.86182-16.65112 19.74951-20.52 22.67993-3.238 2.45264-7.04468 4.93555-10.08008 10.08008-3.15527 5.34741-2.5271 8.57105-3.96 13.67993-4.48242 15.98291-21.71753 23.97193-25.91992 25.91992-6.072 2.8147-13.82593 6.4087-17.63989 3.24C454.33428 330.534 453.17877 327.1031 459.82647 302.58626zM397.30645 181.9864c2.48291-.26343 3.13867-7.58667 6.24-32.64013 2.51392-20.30811 2.90137-22.10865 1.43994-25.91993-4.02221-10.489-12.38061-10.99414-14.87988-22.08007-1.61206-7.15015 1.55981-8.29419-.48-16.31983-.49561-1.94971-3.0332-11.93457-11.52-17.28-5.14331-3.2395-6.65039-1.10864-14.87988-4.8-6.43457-2.88623-6.36328-4.57031-13.92017-8.63989-8.43164-4.54053-13.83276-7.449-18.24-5.28-5.07349 2.49683-6.846 10.74585-5.76 16.79981 1.2815 7.14355 5.80567 7.12036 8.16016 14.88012 2.25219 7.42261-1.32788 9.28858 0 20.6399.73974 6.32373 1.3081 11.18066 4.7998 15.3601 5.00269 5.9878 9.83325 3.19556 17.28 9.6001 5.55615 4.77832 8.10156 10.83447 9.6001 14.3999 3.59521 8.554 1.18823 10.07642 4.32007 14.87989 4.61718 7.08154 10.55444 4.85449 18.24 12.48022C394.88629 175.19 394.85821 182.24617 397.30645 181.9864zM352.18658 265.02644a25.6497 25.6497 0 00-3.36011-20.16016c-.8418-1.25292-6.63769-9.61328-15.35986-10.07983-7.21924-.38623-9.07373 5.02979-17.76 4.79981-1.47949-.03907-7.593-.20093-12-4.31983-4.54322-4.24609-2.65161-8.37817-5.76-13.44018-6.44336-10.49244-27.5376-13.853-35.52-6.72-1.91089 1.70752-3.7063 4.58472-9.12012 9.12012-3.66016 3.06616-5.05322 3.60547-5.76 3.84009-5.32251 1.76611-7.906-1.7439-12-.48022-4.86767 1.50268-8.97095 8.85888-7.2 14.88012 1.78906 6.08277 8.82251 8.252 10.08008 8.63989 7.3623 2.27076 10.168-2.18969 17.28 0a19.29559 19.29559 0 0111.52 10.08008c1.73 3.87647.50195 5.48682 2.3999 11.04a35.66043 35.66043 0 005.28 9.59986c6.41479 7.89941 17.98169 8.74877 23.04 9.12011C317.62823 292.39143 347.2918 284.09822 352.18658 265.02644z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e06714",
    d: "M277.30643 243.90631a127.93281 127.93281 0 0126.17871 5.334c4.27612 1.31055 8.46631 2.89453 12.604 4.603 4.1106 1.772 8.16724 3.67969 12.11206 5.80127a141.41975 141.41975 0 0122.31055 14.87549 129.44946 129.44946 0 0118.95483 18.82617 229.13485 229.13485 0 00-20.38672-16.97412c-3.57959-2.56934-7.16015-5.13379-10.91089-7.437-3.71728-2.34961-7.49145-4.6128-11.38793-6.64991a183.306 183.306 0 00-24.04493-10.83642A222.39862 222.39862 0 00277.30643 243.90631zM310.90652 158.94635a355.03144 355.03144 0 0131.8855 27.12256c5.03735 4.84546 9.95557 9.82544 14.61865 15.05957 2.39087 2.56152 4.56665 5.32275 6.82178 8.01172 1.10376 1.36547 2.13623 2.79418 3.20752 4.18872l1.593 2.10449 1.48242 2.19482 1.46411 2.20752c.47925.74243 1.00122 1.45313 1.41235 2.24536l2.60474 4.64844c.78247 1.59522 1.46338 3.24463 2.19776 4.86475l.53784 1.22119.43408 1.25781.85742 2.52a99.09109 99.09109 0 014.21143 20.71289 145.62168 145.62168 0 01-2.28858 41.80029 175.28327 175.28327 0 001.17725-20.82031 161.9753 161.9753 0 00-1.21485-20.7168 104.42122 104.42122 0 00-4.57763-20.06982L376.471 235.084l-.42481-1.20947-.5249-1.16553c-.71606-1.5459-1.37427-3.11865-2.13379-4.64355l-2.53516-4.45093c-.84912-1.48144-1.88891-2.86523-2.81933-4.30518l-1.427-2.1455-1.54786-2.072c-1.04174-1.37427-2.041-2.77906-3.11767-4.1294-2.19629-2.67041-4.34448-5.37744-6.655-7.96167-4.48608-5.2793-9.323-10.2644-14.1333-15.27368q-7.30591-7.43042-14.88574-14.61231C321.25882 168.27691 316.08646 163.61578 310.90652 158.94635z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e06714",
    d: "M352.94241 83.10626a109.3776 109.3776 0 0110.20313 10.47607q4.782 5.54664 9.0542 11.52393a150.83942 150.83942 0 0114.61059 25.45288 136.87044 136.87044 0 019.19849 27.95142q.41895 1.79772.71582 3.61987c.2063 1.21289.4353 2.42236.62256 3.63843.30737 2.44165.70385 4.87378.88061 7.33056a116.9215 116.9215 0 01.51465 14.739l-.04712 3.68432-.03174 1.8418-.14282 1.83521-.57251 7.33984-.14355 1.83472-.24683 1.82251-.49707 3.64428-.49731 3.6438-.25049 1.82154-.35034 1.80419-1.40235 7.21436c-.21289 1.20679-.498 2.39722-.79492 3.58472l-.86572 3.56836c-1.0586 4.7832-2.54761 9.44921-3.89551 14.14941a258.65278 258.65278 0 01-23.58594 53.479 277.53552 277.53552 0 0011.94019-26.60839c3.55884-9.04 6.6604-18.24415 9.40307-27.542 5.19117-18.65234 8.885-37.82861 8.98291-57.15258a114.13789 114.13789 0 00-.43237-14.43506c-.16016-2.40284-.53833-4.78247-.82642-7.17237-.17749-1.19018-.39648-2.37451-.59252-3.56225l-.29786-1.78125-.36035-1.76953a142.01382 142.01382 0 00-8.56177-27.59034c-1.85937-4.45947-3.98168-8.80932-6.26538-13.0747q-3.41967-6.40246-7.416-12.48828A148.62025 148.62025 0 00352.94241 83.10626zM457.78641 135.42633a15.09335 15.09335 0 01-.21021 5.30346 35.16538 35.16538 0 01-1.44507 5.14576 72.09711 72.09711 0 01-4.45019 9.71753 137.30633 137.30633 0 01-12.06177 17.59912c-4.36206 5.5581-8.78662 11.06421-12.98242 16.71606a136.84491 136.84491 0 00-11.543 17.48194 60.79125 60.79125 0 00-4.07715 9.5039c-.53638 1.64087-1.0166 3.30347-1.42993 4.98975-.19067.81787-.5 1.74292-.76025 2.61987l-.40894 1.32935-.50562 1.26074-1.02294 2.51172-1.13526 2.43408c-.73828 1.63428-1.56177 3.2124-2.37451 4.79687-1.62231 3.17041-3.35254 6.27247-5.13867 9.33741-7.10108 12.2832-14.90357 24.1084-23.09326 35.65234 3.57983-6.10547 7.22216-12.16357 10.70239-18.31592 3.53613-6.1167 7.00244-12.27 10.34521-18.4751a173.5967 173.5967 0 009.05982-18.9458l.45849-1.20874.35767-1.20922c.23462-.81958.49683-1.56983.70264-2.47583.41674-1.75025.90625-3.49 1.457-5.21241a63.22567 63.22567 0 014.21216-9.99316 134.5744 134.5744 0 0111.939-17.79541q6.54675-8.40785 13.43213-16.47852a156.86364 156.86364 0 0012.60815-16.86621 71.009 71.009 0 004.97242-9.26147 35.50855 35.50855 0 001.74267-4.95825A14.89031 14.89031 0 00457.78641 135.42633zM392.50662 271.79645c4.82691-4.43506 9.88648-8.582 15.0481-12.5918 5.15307-4.023 10.449-7.85742 15.81836-11.5918 5.41552-3.66846 10.89795-7.25146 16.58789-10.51269 1.43164-.80127 2.865-1.60157 4.31006-2.377 1.43188-.79443 2.9375-1.47851 4.40258-2.21435a51.61523 51.61523 0 019.21289-3.48242 85.52893 85.52893 0 00-8.509 4.77685c-2.77026 1.69141-5.46094 3.52-8.18384 5.28711-2.67407 1.85449-5.40942 3.60352-8.06884 5.481-2.70289 1.80615-5.37281 3.66992-8.05372 5.51269L417.0159 255.609c-2.71118 1.80615-5.36841 3.6914-8.09278 5.48437C403.51468 264.73687 398.08182 268.35162 392.50662 271.79645zM451.06644 323.58648c5.2351-5.30908 10.5227-10.52539 15.81225-15.73193 5.27-5.2251 10.57617-10.40332 15.75806-15.69775 2.64624-2.59326 5.19043-5.28272 7.77417-7.93409l3.84131-4.0083 3.78247-4.06152c4.99707-5.45947 9.91845-10.97949 14.47192-16.88672A116.028 116.028 0 01499.80179 277.688c-2.33057 2.92334-4.84107 5.68506-7.31836 8.47754-1.2417 1.39355-2.55567 2.71679-3.83008 4.07861q-1.91529 2.04053-3.88672 4.023-3.95214 3.958-8.01147 7.7998c-2.74781 2.51709-5.46094 5.06934-8.28882 7.4961C462.85745 314.46441 457.11355 319.21637 451.06644 323.58648z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 309.12,
    height: 13.92,
    x: 168.346,
    y: 281.826,
    fill: "#f9ae2b",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 180.72,
    height: 13.92,
    x: 305.747,
    y: 267.906,
    fill: "#409cb5",
    rx: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#409cb5",
    d: "M427.44332,438.30636H218.36968a9,9,0,0,1-8.80711-7.14665L181.0665,295.74636h283.68L436.25043,431.15971A9,9,0,0,1,427.44332,438.30636Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 36.24,
    height: 12.24,
    x: 231.066,
    y: 438.306,
    fill: "#f9ae2b",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 36.24,
    height: 12.24,
    x: 378.507,
    y: 438.306,
    fill: "#f9ae2b",
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 10.92,
    height: 94.56,
    x: 318.582,
    y: 319.746,
    fill: "#3086a3",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 10.92,
    height: 94.56,
    x: 356.594,
    y: 319.746,
    fill: "#3086a3",
    rx: 2,
    transform: "rotate(9.254 362.054 367.027)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 10.92,
    height: 94.56,
    x: 394.606,
    y: 319.746,
    fill: "#3086a3",
    rx: 2,
    transform: "rotate(12.256 400.067 367.026)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 10.92,
    height: 94.56,
    x: 273.332,
    y: 319.746,
    fill: "#3086a3",
    rx: 2,
    transform: "rotate(170.746 278.792 367.026)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 10.92,
    height: 94.56,
    x: 235.32,
    y: 319.746,
    fill: "#3086a3",
    rx: 2,
    transform: "rotate(167.744 240.78 367.026)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 496.355,
    x2: 528.658,
    y1: 172.683,
    y2: 172.683,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 496.355,
    x2: 528.658,
    y1: 181.993,
    y2: 181.993,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 496.355,
    x2: 528.658,
    y1: 191.304,
    y2: 191.304,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 99.916,
    x2: 132.218,
    y1: 299.171,
    y2: 299.171,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 99.916,
    x2: 132.218,
    y1: 308.481,
    y2: 308.481,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 99.916,
    x2: 132.218,
    y1: 317.792,
    y2: 317.792,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 448.595,
    x2: 480.898,
    y1: 428.599,
    y2: 428.599,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 448.595,
    x2: 480.898,
    y1: 437.91,
    y2: 437.91,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 448.595,
    x2: 480.898,
    y1: 447.22,
    y2: 447.22,
    fill: "none",
    stroke: "#b9d4db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.028,
    cy: 225.373,
    r: 16.428,
    fill: "#b9d4db"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.694,
    cy: 191.878,
    r: 8.557,
    fill: "#b9d4db"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.689,
    cy: 196.878,
    r: 7.406,
    fill: "#b9d4db"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.745,
    cy: 189.681,
    r: 4.936,
    fill: "#b9d4db"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.481,
    cy: 216.624,
    r: 11.833,
    fill: "#b9d4db"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.548,
    cy: 429.814,
    r: 16.428,
    fill: "#b9d4db"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.776,
    cy: 437.91,
    r: 8.557,
    fill: "#b9d4db"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.776,
    cy: 403.271,
    r: 11.833,
    fill: "#b9d4db"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.865,
    cy: 347.252,
    r: 16.428,
    fill: "#b9d4db"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 517.277,
    cy: 363.68,
    r: 7.406,
    fill: "#b9d4db"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 508.198,
    cy: 335.419,
    r: 11.833,
    fill: "#b9d4db"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptycart);
export default __webpack_public_path__ + "static/media/emptycart.9ec1c35a2092e9db39c4e0dfe9b16c25.svg";
export { ForwardRef as ReactComponent };